import { ITableField } from 'shared/Table'
import { ITeamDefence } from 'screens/Protection/protection.types'

const gradeTableFields: ITableField<ITeamDefence, any>[] = [
  {
    key: 'defenceName',
    getter: (item: ITeamDefence) => item.defenceName || '--',
    sortGetter: (item: ITeamDefence) => item.defenceName || '',
    header: 'Защита',
    width: '220px',
  },

  {
    key: 'teamName',
    getter: (item: ITeamDefence) => item.teamName || '--',
    sortGetter: (item: ITeamDefence) => item.teamName || '',
    header: 'Команда',
    width: '200px',
  },

  {
    key: 'roomName',
    getter: (item: ITeamDefence) => item.roomName || '--',
    sortGetter: (item: ITeamDefence) => item.roomName || '',
    header: 'Комната',
    width: '200px',
  },

  {
    key: 'currentTotalScore',
    getter: (item: ITeamDefence) => (item.currentTotalScore !== null ? item.currentTotalScore.toString() : '--'),
    sortGetter: (item: ITeamDefence) => item.currentTotalScore ?? 0,
    header: 'Баллы',
    width: '140px',
  },
]

export default gradeTableFields
